<template>
    <div class="home">
     
      <DetalleSolicitudesInspeccionComponent />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import DetalleSolicitudesInspeccionComponent from '@/components/DetalleSolicitudesInspeccionComponent.vue'
  
  export default {
    name: 'CotizacionView',
    components: {
        DetalleSolicitudesInspeccionComponent
    }
  }
  </script>